import { render, staticRenderFns } from "./LxUserHelp.vue?vue&type=template&id=d03139e8"
import script from "./LxUserHelp.vue?vue&type=script&lang=js"
export * from "./LxUserHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports